import React, { useCallback, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { selectRetailerState } from "../../../store/retailer/retailerFilterSlice";
import { CustomDropdown } from "../../../component/customdropdown/CustomDropdown";
import {
  clearSearchFilter,
  setSearchFilter,
  setStatusFilter,
} from "../../../store/retailer/retailerFilterSlice";
import classes from "./retailerFilterPage.module.css";
import { SearchInput } from "../../../component/shared/formElements/searchInput/SearchInput";
import { useGetRetailersListQuery } from "../../../services/retailers/retailersApiSlice";

const statusData = [
  { id: "", label: "Select Status" },
  { id: "1", label: "Incomplete" },
  { id: "2", label: "Pending for verification" },
  { id: "3", label: "Verified" },
  { id: "4", label: "Rejected" },
];

export const RetailersFilterPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { status, search } = useSelector(selectRetailerState);
  useEffect(() => {
    const statusParam = searchParams.get("status") ?? "";
    const searchParam = searchParams.get("search") ?? "";

    dispatch(setStatusFilter(statusParam));
    dispatch(setSearchFilter(searchParam));
  }, [searchParams, dispatch]);

  const updateURLAndStore = useCallback(
    (key, value) => {
      const newParams = new URLSearchParams(searchParams);
      if (value) newParams.set(key, value);
      else newParams.delete(key);

      setSearchParams(newParams);

      if (key === "status") dispatch(setStatusFilter(value));
      if (key === "search")
        dispatch(value ? setSearchFilter(value) : clearSearchFilter());
    },
    [dispatch, searchParams, setSearchParams]
  );

  useGetRetailersListQuery({ status, search });

  return (
    <div className={classes.box}>
      <div className={classes.box__content}>
              <h1 className={classes.box__content__title}>Retailers</h1>
            </div>
      {/* Search Input */}
      <div className={classes.box__content}>
        <SearchInput
          placeholder="Search by name or phone number"
          value={search}
          onSearch={(text) => updateURLAndStore("search", text)}
          onClear={() => updateURLAndStore("search", "")}
        />
      </div>

      {/* Custom Select Dropdown */}
      <div className={classes.box__content}>
        {/* <CustomSelect
          name="status"
          label="Select All"
          options={optionData}
          onSelection={handleSelection}
          selectedId={filters.status || ""}
        /> */}
        <CustomDropdown
          id="status"
          label="Select Status"
          options={statusData}
          selectedId={status || ""}
          onSelection={(_, value) => updateURLAndStore("status", value)}
        />
      </div>
    </div>
  );
};
